import { SVGProps } from 'react';

export const SwitchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.293 8.29297L14.707 9.70697L19.414 4.99997L14.707 0.292969L13.293 1.70697L15.586 3.99997H4V5.99997H15.586L13.293 8.29297Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.70694 9.70697L5.29294 8.29297L0.585938 13L5.29294 17.707L6.70694 16.293L4.41394 14H15.9999V12H4.41394L6.70694 9.70697Z"
      fill="currentColor"
    />
  </svg>
);
